import React from 'react';
import PropTypes from 'prop-types';
import { isExpired } from '@/utils/dateTimeUtils';
import ConnectButton from '@/pages/_banner/ConnectButton';
import Wrapper from '@/pages/_banner/Wrapper';
import { DialogManager } from '@/dialogs_new/DialogManager';
import useDialogLauncher from '@/dialogs-routable/_hooks/useDialogLauncher';
import usePageRouter from '@/dialogs-routable/_hooks/usePageRouter';

DiscoverBanner.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    data: PropTypes.shape({
      date: PropTypes.string
    })
  }).isRequired,
  creator: PropTypes.shape({
    data: PropTypes.shape({
      firstName: PropTypes.string
    })
  }).isRequired
};

export default function DiscoverBanner(props) {
  const { event, creator } = props;

  const launch = useDialogLauncher();
  const { history } = usePageRouter();

  function showYesDialog() {
    launch(DialogManager.InvitationDiscoverYes.Config(event.id));
  }

  function showMaybeDialog() {
    launch(DialogManager.InvitationDiscoverMaybe.Config(event.id));
  }

  if (
    isExpired(event.data.date)
  ) {
    return (
      <Wrapper
        color="gray"
        creator={creator}
        title="The timeframe for this event has ended."
        subtitle={(
          <>
            But you can explore other opportunities to collaborate and make an impact.
          </>
        )}
      >
        <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
          <ConnectButton color="gray" onClick={() => history.push(`/opportunities`)}>
            Explore opportunities
          </ConnectButton>
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper
      creator={creator}
      title={`Want to get involved with ${creator.data.firstName}'s event?`}
      subtitle={(
        <>
          Let {creator.data.firstName} know you&apos;re interested in collaborating! You can ask
          questions and adjust your commitment later if necessary.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={showMaybeDialog}>
          I have some questions first
        </ConnectButton>
        <ConnectButton onClick={showYesDialog}>
          Yes, count me in
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
